/**
 * @file
 * Example of a custom script file.
 */
((Drupal,$, drupalSettings) => {
  Drupal.behaviors.AnalyticsGDSSubthemeGlobal = {
    attach: (context, settings) => {

      let sectionTitle = '';
      if ($('body').hasClass('category-89')) {
        sectionTitle = 'オフェブ';
      } else if ($('body').hasClass('category-88')) {
        sectionTitle = 'ジャスケイド';
      }

      //metanav analytics
      var values = ["文字サイズ", sectionTitle+"-global-header-text-size-medium", sectionTitle+"-global-header-text-size-big", sectionTitle+"-global-header-logo-肺線維症.jpへ"]; // Your values here
      $('.gds-header .gds-metanav__menu .gds-metanav__item:not(:first-child) .gds-link').each(function (index) {
          $(this).attr('data-it-button', 'button:' + values[index]);
      });

      //main navigation submenu analytics
      $('.gds-header .gds-mega-nav-main .gds-submenu-item a.gds-link').each(function (index) {
           $(this).attr('data-it-button', 'button:'+ sectionTitle +'-global-header-sub-menu-' + $(this).find('span[itemprop="name"]').text().trim());
      });

      //header logo analytics
       $('.gds-header a.gds-logo').each(function (index) {
           $(this).attr('data-it-button', 'button:'+ sectionTitle +'-global-header-logo-'+sectionTitle);
      });

      //quicklinks analytics
      $('.gds-quicklinks .gds-quicklinks__item a.gds-link').each(function (index) {
         const title = ($(this).attr('title') || '').trim();
          $(this).attr(
              'data-it-button',
              'button:' + sectionTitle + '-quicklinks-' + title
          );
      });

      // Adobe analytics for footer links.
       $('.gds-sitemap-block .gds-sitemap-block__item a.gds-link').each(function (index) {
        const title = ($(this).attr('title') || '').trim();
          $(this).attr(
              'data-it-button',
              'button:' + sectionTitle + '-footer'+ title
          );
      });

      //profile cards analytics
      $('.ofev-above-footer-content-section .gds-card .gds-card__cta a.gds-link').each(function (index) {
        var profileValue = $(this).find('span:last').text().trim();
          $(this).attr(
              'data-it-button',
              'button:'+sectionTitle+'-'+ profileValue
          );
      });

      //ofev cards analytics
      var ofevValues = [ sectionTitle+"-肺線維症と共にへ", sectionTitle+"-進行性肺線維症（PPF）", sectionTitle+"-IPF オフェブ服用者サイトへ", sectionTitle+"-PWA 治療日誌へ"]; // Your values here
      $('.ofev-card-section .gds-card a.gds-link').each(function (index) {
          $(this).attr('data-it-button', 'button:' + ofevValues[index]);
      });

      //jas homepage cards analytics
      var jasValues = [ sectionTitle+"-IPF オフェブ服用者サイトへ", sectionTitle+"-肺線維症と共にへ", sectionTitle+"-進行性繊維化を伴う間質性肺疾患", sectionTitle+"-進行性肺線維症（PPF）"]; // Your values here
      $('.jas-footer-above-cards .gds-card a.gds-link').each(function (index) {
          $(this).attr('data-it-button', 'button:' + jasValues[index]);
      });

      //footer logo analytics
      $('.gds-footer a.gds-logo').each(function (index) {
        $(this).attr(
              'data-it-button',
              'button:' + sectionTitle + '-footer-logo-BI'
          );
      });

      //footer links analytics
      $('.gds-footer .gds-footer__legal-links .gds-inline-menu__item a.gds-link').each(function (index) {
        const title = ($(this).attr('title') || '').trim();
        $(this).attr(
              'data-it-button',
              'button:' + sectionTitle + '-footer-'+ title
          );
      });

      //sidebar analytics
        $('.menu-tab-section .sidebar-menu-title.menu-tab-link a').each(function (index) {
          $(this).attr('data-it-button', 'button:'+sectionTitle+'-right-side-navigation-' + $(this).text());
        });

      //article navigation 
      $('.gds-article-navigation .gds-article-navigation__item a.gds-link').each(function (index) {
        const title = ($(this).attr('title') || '').trim();
        $(this).attr(
              'data-it-button',
              'button:' + sectionTitle + '-'+ title
          );
      });

      //breadcrumb analytics
      $('.gds-breadcrumb__list-item:not(:last-child').each(function (index, el) {
      $(this).find('a.gds-link--breadcrumb').attr('data-it-button', 'link:'+ sectionTitle + '-' + $(this).find('.gds-link__label').text().trim());
      });

      //three buttons on financial assistance
      $('.hss4-443, .hss4-444, .hss4-445')
        .find('.ofev-content-section .gds-card .gds-card__cta a.gds-link')
        .each(function () {
          const title = $(this).find('span:last').text().trim();
          $(this).attr(
            'data-it-button',
            'button:' + sectionTitle + '-' + title
          );
      });



    },
  };
})(Drupal, jQuery, drupalSettings);
